import script from "./applicationModel.vue?vue&type=script&setup=true&lang=jsx"
export * from "./applicationModel.vue?vue&type=script&setup=true&lang=jsx"

import "./applicationModel.vue?vue&type=style&index=0&id=5d0d1f66&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0d1f66"]])

export default __exports__